module.exports = __webpack_public_path__ + "static/media/screenshot2.fd549d75.jpg";